module.exports = "/images/food.jpg";